import { authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

export function checkReportList(params) {
  return authPost(`${baseUrl}/Agent5.ashx`, params);
}

export function checkDetailsReportList(params) {
  return authPost(`${baseUrl}/Agent10.ashx`, params);
}

export function postAgent12(params) {
  return authPost(`${baseUrl}/Agent12.ashx`, params);
}

export function postAgent17(params) {
  return authPost(`${baseUrl}/Agent17.ashx`, params);
}

export function postAgent13(params) {
  return authPost(`${baseUrl}/Agent13.ashx`, params);
}
